export const MERCHANT_WIDGET_IFRAME_ID = "merchantwidgetiframe";
export const MERCHANT_WIDGET_IFRAME_TITLE = "Google customer reviews";

// Google's merchantwidget.js injects the Top Quality Store badge as
// <iframe id="merchantwidgetiframe"> with no `title`. A titleless iframe is a
// WCAG 4.1.2 violation (axe frame-title) — screen readers announce a nameless
// frame. Give it an accessible name once it appears; skip it if it already has
// a (non-empty) title, and no-op when the badge isn't present.
export const setMerchantWidgetIframeTitle = (doc = document) => {
  const iframe = doc.getElementById(MERCHANT_WIDGET_IFRAME_ID);

  if (iframe && !iframe.getAttribute("title")) {
    iframe.setAttribute("title", MERCHANT_WIDGET_IFRAME_TITLE);
  }

  return iframe;
};
